<template>
    <DCard
        class="tenant"
        :class="{selected: selected, active: active}"
        footer-padding
        @click="click"
    >
        <template #default>
            <div
                v-if="active"
                class="logo"
            >
                <img
                    :src="'data:image/svg+xml;base64,' + currentLogo"
                    :alt="companyName"
                >
            </div>
        </template>
        <template #footer>
            <h1>{{ companyName }}</h1>
        </template>
    </DCard>
</template>

<script>
export default {
    name: 'TenantItem',
    props: {
        selected: {
            type: Boolean,
            default: false
        },
        active: {
            type: Boolean,
            default: true
        },
        companyName: {
            type: String,
            default: ''
        },
        logo: {
            type: String,
            default: ''
        },
        logoDark: {
            type: String,
            default: ''
        }
    },
    emits: ['click'],
    data () {
        return {
            isDarkMode: false
        }
    },
    computed: {
        currentLogo () {
            if (this.isDarkMode && this.logoDark) {
                return this.logoDark
            }
            return this.logo
        }
    },
    mounted () {
        this.isDarkMode = document.body.classList.contains('dark-mode')
        this.emitter.on('theme-changed', this.onThemeChanged)
    },
    beforeUnmount () {
        this.emitter.off('theme-changed', this.onThemeChanged)
    },
    methods: {
        click () {
            this.$emit('click')
        },
        onThemeChanged (isDark) {
            this.isDarkMode = isDark
        }
    }
}
</script>

<style lang="scss" scoped>
.tenant {
    width: 100%;
    padding: 15px;
    box-sizing: border-box;

    & .logo {
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;

        & img {
            height: 40px;
            max-width: 100%;
            object-fit: contain;
        }
    }
    & h1 {
        font-size: 16px;
        justify-self: center;
        margin: 0;
    }
    &:hover {
        background: rgba(0,0,0,0.035);
        cursor: pointer;
    }
    &.selected {
        border-color: #f5c844;
        background: rgb(254, 250, 237);
    }
}
</style>
